import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { ToastController } from "ionic-angular";
import { AlertController, NavController, NavParams } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Status } from "../../models/interfaces/status.model";
import { SettingsPage } from "../../pages/settings/settings";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-settings_update",
  templateUrl: "settings_update.html",
})
export class SettingsUpdatePage {
  private status$;
  private settingForm: FormGroup;
  private setting;
  private attribute1_name: string;
  private attribute2_name: string;
  private styleName: string ="";

  constructor(private configService: ConfigService,public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, private db: DbserviceProvider,
              private camera: Camera, private alertCtrl: AlertController,
              private toastCtrl: ToastController,
  ) {
    console.log("SettingsUpdatePage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.setting = this.navParams.get("settings");
    if (this.setting.se_class === "Expenses" ) {
      this.attribute1_name = "Auto Add";
      this.attribute2_name = "Qty Auto Add";
    }
    else{
      this.attribute1_name = "Attribute1";
      this.attribute2_name = "Attribute2";
    }
    this.settingForm = this.formBuilder.group({
      "se_attribute1": [this.setting.se_attribute1],
      "se_attribute2": [this.setting.se_attribute2],
      "se_class": [this.setting.se_class , [Validators.required]],
      "se_id": [this.setting.se_id ],
      "se_key_name": [this.setting.se_key_name, [Validators.required]],
      "se_key_value": [this.setting.se_key_value , [Validators.required]],
      "se_name_description": [this.setting.se_name_description, [Validators.required]],
      "se_order": [this.setting.se_order],
    });
  }

  private onInitPage() {
    console.log("SettingsUpdatePage onInitPage");
  }

  private ngOnDestroy() {
    console.log("SettingsUpdatePage ngOnDestroy");
    this.status$ = null;
  }

  private goback() {
    console.log("SettingsUpdatePage goback");
    this.navCtrl.pop();
  }

  private updateSettings(formValues: any) {
    console.log("SettingsUpdatePage updateSettings", formValues);
    this.db.dbCol({ "action": "update", "mapObject": "settings", ...formValues }).subscribe((ret) => {
      this.navCtrl.pop();
    });
  }

  private sendNotification(message: string): void {
    console.log("SettingsUpdatePage sendNotification");
    let notification = this.toastCtrl.create({
      "duration": 3000,
      "message": message,
    });
    notification.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings_update.ts